<template>
	<div class="WallInfo">
		<h3>Info and Links</h3>
		<ul>
			<li>Id: {{$route.params.clientId}}</li>
		</ul>
		<h4>Links</h4>
		<router-link :to="{name:'PrayerWall', params: {clientId: $route.params.clientId}}">Standalone Wall</router-link> | 
		<router-link :to="{name: 'SlideShow', params: {clientId: $route.params.clientId}}">Slideshow Mode</router-link>
		<HBreak/>
		<h3>Integration</h3>
		<h4>iFrame</h4>
		<p>Copy the below iframe script and embed it into your website:</p>
		<div class="iFrameScriptContainer">
			{{iFrameScript}}
		</div>

		<div>
			Display Options: 
			<input type="checkbox" id="hideTitleCheck" v-model="hideTitleHeader" /><label for="hideTitleCheck">Hide Title</label> | 
			<input type="checkbox" id="noMarginCheck" v-model="marginlessMode" /><label for="noMarginCheck">Marginless</label>
		</div>

		<!--
		<h3>Active Integrations</h3>
		<ul>
			<li>Integration 1</li>
		</ul>
	-->
	</div>
</template>

<script setup>
	import { useIframeScript } from '@/composables/iFrameScript';
	import {useRoute} from "vue-router";
	import HBreak from '@/components/HBreak.vue';

	import {ref} from "vue";

	let route = useRoute();
	let {iFrameScript, hideTitleHeader, marginlessMode} = useIframeScript(route.params.clientId)
	hideTitleHeader.value = true;
	


</script>

<style scoped>
	.iFrameScriptContainer{
		max-width: 1000px;
		margin-left: auto;
		margin-right: auto;
		margin-top: 20px;
		margin-bottom: 20px;

		border-style: solid;
		border-color: #2c3e50;
		background-color: #f2f7fb5e;
		padding: 10px;

		font-family:'Courier New', Courier, monospace;
		color: #2c3e50;
		
	}
</style>